module.exports = __webpack_public_path__ + "static/media/logo.764d743a.png";